var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
import QuotedPrice from '../../../api/QuotedPrice';
import AddGoodTable from './AddGoodTable.vue';
import _ from 'lodash';
var EActiveType;
(function (EActiveType) {
    EActiveType["\u5F85\u9009\u62E9"] = "0";
    EActiveType["\u5DF2\u9009\u62E9"] = "1";
})(EActiveType || (EActiveType = {}));
var AddDialog = (function (_super) {
    __extends(AddDialog, _super);
    function AddDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.code = '';
        _this.groups = [];
        _this.activeName = '0';
        _this.periodicList = [];
        _this.total = 0;
        _this.formData = {
            price_cycle: 0,
            keyword: ''
        };
        _this.unSelectList = [];
        _this.selectedList = [];
        _this.canFreshTable = true;
        _this.loading = false;
        return _this;
    }
    AddDialog.prototype.created = function () {
        this.service = QuotedPrice.getInstance();
        this.selectedList = [];
        this.getGoodList();
        this.getPriceCycle();
    };
    AddDialog.prototype.getIds = function (arr, key) {
        if (!this.purchasers)
            return null;
        return _.reduce(arr, function (ori, newItem) {
            return ori += ori ? (',' + newItem[key]) : newItem[key];
        }, '');
    };
    AddDialog.prototype.getGoodList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        this.loading = true;
        var clients = _.uniqBy(this.purchasers, 'supplier_to_business_id');
        var supplier_to_business_id = this.getIds(clients, 'supplier_to_business_id');
        var goods_ids;
        if (this.added_goods_ids.length) {
            goods_ids = this.added_goods_ids;
        }
        else {
            goods_ids = this.getIds(this.addedDatas, 'business_goods_id');
        }
        this.service.getGoodList(Object.assign({ supplier_to_business_id: supplier_to_business_id, goods_ids: goods_ids }, this.formData, pager)).then(function (res) {
            if (res.data.success) {
                _this.unSelectList = res.data.data;
                _this.total = res.data.total;
                _this.setSelected(true);
            }
            else {
                _this.$message.error(res.data.msg);
            }
            _this.loading = false;
        }, function (err) {
            _this.$message.error(err.message);
            _this.loading = false;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
            _this.loading = false;
        });
    };
    AddDialog.prototype.getPriceCycle = function () {
        var _this = this;
        this.service.getPriceCircleList().then(function (res) {
            if (res.data.success) {
                _this.periodicList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        });
    };
    AddDialog.prototype.selectChange = function (rows, currentRow, isSelectAll) {
        var _this = this;
        if (isSelectAll === void 0) { isSelectAll = false; }
        if (!this.canFreshTable)
            return;
        this.canFreshTable = false;
        var currentSelectRows = _.filter(rows, function (row) { return !!row; });
        this.selectedList = _.uniqBy(this.selectedList.concat(currentSelectRows), function (item) { return item.supplier_to_business_id + "_" + item.business_goods_id; });
        var isUnselectAll = !currentSelectRows.length && !currentRow && isSelectAll;
        if (currentRow && !_.find(currentSelectRows, { supplier_to_business_id: currentRow.supplier_to_business_id, business_goods_id: currentRow.business_goods_id })) {
            _.remove(this.selectedList, function (item) { return item.supplier_to_business_id === currentRow.supplier_to_business_id && item.business_goods_id === currentRow.business_goods_id; });
        }
        else if (isUnselectAll && this.activeName === EActiveType.已选择) {
            this.selectedList = [];
        }
        else if (isUnselectAll) {
            this.unSelectList.forEach(function (good) {
                _.remove(_this.selectedList, function (item) { return item.supplier_to_business_id === good.supplier_to_business_id && item.business_goods_id === good.business_goods_id; });
            });
        }
        this.setSelected(this.activeName === EActiveType.已选择);
        setTimeout(function () {
            _this.canFreshTable = true;
        });
    };
    AddDialog.prototype.setSelected = function (isUnSelFresh) {
        var _this = this;
        if (isUnSelFresh === void 0) { isUnSelFresh = false; }
        var gridTable = this.$refs.grid.$refs.table;
        if (isUnSelFresh) {
            gridTable.clearSelection();
        }
        if (!this.selectedList.length) {
            this.$refs.alreadyGrid.$refs.table.clearSelection();
        }
        else {
            this.$nextTick(function () {
                var alreadyGridTable = _this.$refs.alreadyGrid.$refs.table;
                _this.selectedList.forEach(function (good, index) {
                    alreadyGridTable.toggleRowSelection(good, true);
                    if (isUnSelFresh) {
                        var item = _.find(_this.unSelectList, function (current) {
                            return current.supplier_to_business_id === good.supplier_to_business_id &&
                                current.business_goods_id === good.business_goods_id;
                        });
                        if (item) {
                            gridTable.toggleRowSelection(item, true);
                        }
                    }
                });
            });
        }
    };
    AddDialog.prototype.search = function () {
        this.getGoodList();
    };
    AddDialog.prototype.close = function () {
        this.$closeDialog();
    };
    AddDialog.prototype.submitData = function () {
        var data = _.uniqBy(this.selectedList.concat(this.addedDatas), function (item) { return item.supplier_to_business_id + "_" + item.business_goods_id; });
        this.$emit("submit", data);
        this.close();
    };
    AddDialog.prototype.pageChange = function (pager) {
        this.getGoodList(pager);
        this.$refs.grid.$refs.table.bodyWrapper.scrollTop = 0;
    };
    AddDialog = __decorate([
        Component({
            components: {
                'add-good-table': AddGoodTable
            },
            computed: {
                isMultiple: function () {
                    return _.uniqBy(this.purchasers, 'business_id').length > 1;
                }
            }
        })
    ], AddDialog);
    return AddDialog;
}(VueDialog));
export default AddDialog;
